// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {InputHTMLAttributes, TextareaHTMLAttributes,
    MutableRefObject} from 'react';
import cn from 'classnames';

import styles from './basic_input.module.less';

export type t_content = string | JSX.Element;
export type t_render_prop = (value?: string)=>JSX.Element;
export type t_input_attrs = InputHTMLAttributes<HTMLInputElement>;
export type t_textarea_attrs = TextareaHTMLAttributes<HTMLTextAreaElement>;

export interface i_basic_input_base {
    value?: string;
    placeholder?: string;
    label?: t_content;
    is_disabled?: boolean;
    is_error?: boolean;
    cls?: string;
    slot_left?: JSX.Element | t_render_prop;
    slot_right?: JSX.Element | t_render_prop;
    slot_bottom?: JSX.Element | t_render_prop;
    on_change?: (value?: string)=>void;
    on_blur?: (value?: string)=>void;
    on_key_down?: (key: string)=>void;
    icon_left?: JSX.Element;
}

export interface i_basic_input_input_props {
    tag?: 'input';
    type?: t_input_attrs['type'];
    input_props?: t_input_attrs;
    input_ref?: MutableRefObject<HTMLInputElement>;
}

export interface i_basic_input_textarea_props {
    tag: 'textarea';
    input_props?: t_textarea_attrs;
    input_ref?: MutableRefObject<HTMLTextAreaElement>;
}

export type i_basic_input_props = i_basic_input_base & (
    | i_basic_input_input_props
    | i_basic_input_textarea_props
);

export const Basic_input = (props: i_basic_input_props)=>{
    const {
        tag = 'input',
        value,
        placeholder,
        label,
        is_disabled,
        is_error,
        slot_left,
        slot_right,
        slot_bottom,
        cls,
        on_change,
        on_blur,
        on_key_down,
        input_ref,
        input_props = {},
        icon_left,
    } = props;
    const type = 'type' in props ? props.type || 'text' : undefined;
    const root_cls = cn(styles.basic_input, cls,
        is_error && styles.is_error,
        is_disabled && styles.is_disabled,
    );
    return <div className={root_cls} data-elem="sh_input">
      {label && <label className={styles.label} data-elem="label">
        {label}
      </label>}
      <div className={styles.wrapper} data-elem="wrapper">
        {typeof slot_left=='function' ? slot_left() : slot_left}
        {icon_left && icon_left}
        {tag === 'textarea' ? <textarea
          data-elem="textarea"
          ref={input_ref as MutableRefObject<HTMLTextAreaElement>}
          value={value}
          placeholder={placeholder}
          disabled={is_disabled}
          onChange={ev=>{ on_change?.(ev.target.value); }}
          onBlur={ev=>{ on_blur?.(ev.target.value); }}
          onKeyDown={ev=>{ on_key_down?.(ev.key); }}
          {...(input_props as t_textarea_attrs)}
        /> : <input
          data-elem="input"
          ref={input_ref as MutableRefObject<HTMLInputElement>}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={is_disabled}
          onChange={ev=>{ on_change?.(ev.target.value); }}
          onBlur={ev=>{ on_blur?.(ev.target.value); }}
          onKeyDown={ev=>{ on_key_down?.(ev.key); }}
          {...(input_props as t_input_attrs)}
        />}
        {typeof slot_right=='function' ? slot_right() : slot_right}
      </div>
      {typeof slot_bottom=='function' ? slot_bottom() : slot_bottom}
    </div>;
};
